import * as modelsGet from "../models/get";
import { getMourningHalls } from "../api/mourningHalls";

var mourningHalls: modelsGet.IMourningHall[];

/**
 * Gibt alle Trauerhallen zurück.
 * @param reload Angabe, ob die Status Einträge erneut aus der Datenbank geladen werden sollen.
 */
export async function getMourningHallsAsync(reload: boolean = false): Promise<modelsGet.IMourningHall[]>
{
    if (mourningHalls == null || reload)
    {
        mourningHalls = await getMourningHalls();
    }

    return mourningHalls;
}